import React from "react"
import { FormattedMessage, injectIntl, FormattedNumber } from "react-intl"
import { Link } from "react-router-dom"
import ActivityFeedEventSearchResult from "../../../state/search/Dto"
import IntlProps from "../../../state/helpers/IntlProps"
import PaymentTypeLabel from "../../../payment/label.component.jsx"

type Props = {
    intl: IntlProps,
    activity: ActivityFeedEventSearchResult,
}

const ActivityFeedEventPaymentCapturedComponent = (props: Props) => {

    const parsedData = JSON.parse(props.activity.getObjectDataJson())
    const paymentAmount = parsedData.amount
    const currency = parsedData.currency
    const paymentTypeId = parsedData.paymentTypeId

    return (
        <>
            <div>
                <FormattedMessage
                    id="dashboard.activity-feed.document-payment-captured"
                    defaultMessage="{customer} made a {paymentType} of {amount} in {identifier}"
                    values={{
                        customer: <Link to={"/contacts/" + props.activity.getContactId() + "/details"}>
                            {props.activity.getContactName()}
                        </Link>,
                        paymentType: <PaymentTypeLabel value={paymentTypeId}/>,
                        identifier:
                            <Link
                                to={"/" + props.activity.getObjectType() + "/" + props.activity.getObjectId() + "/edit"}>
                                {props.activity.getIdentifier()}
                            </Link>,
                        amount: <strong>
                            <FormattedNumber
                                value={paymentAmount}
                                style={"currency"}
                                currency={currency}
                            />
                        </strong>
                    }}
                />
            </div>
        </>
    )
}

export default injectIntl(ActivityFeedEventPaymentCapturedComponent)


// WEBPACK FOOTER //
// ./src/dashboard/activity-feed/components/ActivityFeedEventPaymentCapturedComponent.tsx